/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceEmailSettingsShow } from '../../axios/invoiceEmailSettingsShow'
import type {
	InvoiceEmailSettingsShowError,
	InvoiceEmailSettingsShowPathParams,
	InvoiceEmailSettingsShowResponse,
} from '../../types/InvoiceEmailSettingsShow'

export const invoiceEmailSettingsShowQueryKey = (organisation: InvoiceEmailSettingsShowPathParams['organisation']) =>
	[{ url: '/:organisation/invoice-email-settings', params: { organisation } }] as const

export type InvoiceEmailSettingsShowQueryKey = ReturnType<typeof invoiceEmailSettingsShowQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::show */
export function invoiceEmailSettingsShowQueryOptions(
	organisation: InvoiceEmailSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InvoiceEmailSettingsShowResponse,
		AxiosError<InvoiceEmailSettingsShowError>,
		InvoiceEmailSettingsShowResponse,
		InvoiceEmailSettingsShowQueryKey
	>({
		queryKey: invoiceEmailSettingsShowQueryKey(organisation),
		queryFn: ({ signal }) => invoiceEmailSettingsShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::show */
export function useInvoiceEmailSettingsShow<TSelectData = InvoiceEmailSettingsShowResponse>(
	organisation: InvoiceEmailSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					InvoiceEmailSettingsShowResponse,
					AxiosError<InvoiceEmailSettingsShowError>,
					TSelectData,
					InvoiceEmailSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InvoiceEmailSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...invoiceEmailSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::show */
export function useInvoiceEmailSettingsShowSuspense<TSelectData = InvoiceEmailSettingsShowResponse>(
	organisation: InvoiceEmailSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InvoiceEmailSettingsShowResponse,
					AxiosError<InvoiceEmailSettingsShowError>,
					TSelectData,
					InvoiceEmailSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InvoiceEmailSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...invoiceEmailSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
